import { createContext } from 'react';

var ControlsHeight;
(function (ControlsHeight) {
  ControlsHeight["S"] = "S";
  ControlsHeight["M"] = "M";
  ControlsHeight["L"] = "L";
})(ControlsHeight || (ControlsHeight = {}));
var ControlsHeightContext = /*#__PURE__*/createContext(ControlsHeight.M);
var globalControlsHeight = ControlsHeight.M;
// This can be used if React Context is not applicable, for example for alertService or Auth dialog
function configureGlobalControlsHeight(value) {
  globalControlsHeight = value;
}
function getGlobalControlsHeight() {
  return globalControlsHeight;
}

export { ControlsHeight, ControlsHeightContext, configureGlobalControlsHeight, getGlobalControlsHeight };
